
<template>
    <div>

      <HeroFeatures></HeroFeatures>

      <GettingStarted></GettingStarted>
      <PipelinesUi></PipelinesUi>
      <SourceIntegrations></SourceIntegrations>
      <RealTime></RealTime>

<!--        <LeftFeature-->
<!--                machine-name="simple"-->
<!--                title="Simple set-up"-->
<!--                description="Select any number of sources and destinations and start loading data straight away with no code."-->
<!--                icon="push">-->

<!--        </LeftFeature>-->
<!--        <RightFeature machine-name="automated"-->
<!--                      title="Fully managed and automated data pipelines"-->
<!--                      description="Skippr helps you replicate all your data at scale, in near real-time and ready for analysis.  You have granular visibility into your data flows in every pipeline and view samples of incoming data as it loads from source to destination."-->
<!--                      icon="relationship"-->
<!--        ></RightFeature>-->
<!--        <LeftFeature machine-name="multi-destination"-->
<!--                      title="Multi-Destination Connections"-->
<!--                      description="Having connected to one or more data sources, you can then fan out to multiple destinations. For example, you can connect S3 data source to Google Big Query, On prem Kafka and AmazonSQS and change them at any time!"-->
<!--                      icon="database"-->
<!--        ></LeftFeature>-->
<!--        <RightFeature machine-name="simple"-->
<!--                      title="Data Quality Assurance"-->
<!--                      description="Skippr is your data preparation tool, delivering quality data to your analysts, data warehouse and downstream services. It runs validation checks, automatically fixes any serialisation and format issues and handles schemas drift over time."-->
<!--                      icon="quality"-->
<!--        ></RightFeature>-->
<!--        <LeftFeature machine-name="schema"-->
<!--                     title="Schema management"-->
<!--                     description="Skippr discovers your source schema, handles schema evolution as fields drift over time with manual review.-->
<!--The Skippr schema registry is compatible with confluent REST API, so your existing services can consume the latest scheam versions."-->
<!--                     icon="select"-->
<!--        ></LeftFeature>-->
<!--        <RightFeature machine-name="anomalies-detection"-->
<!--                      title="Anomalies detection"-->
<!--                      description="Detect any data anomalies and automatically queue them for correction in your configurable backend (ex. S3, Kafka). Once corrected, the data will be re-processed with no interruption to your data pipelines."-->
<!--                      icon="loupe"-->
<!--        ></RightFeature>-->
<!--        <LeftFeature machine-name="simple"-->
<!--                     title="Highly-Optimise for Data Query"-->
<!--                     description="Boost your query performance and cost efficiency while landing real-time data faster and more reliably. Configure optimal output formats and data structure for each destination you select. From json to Parquet, XML to Avro, accelerate your data analysis during ingestion."-->
<!--                     icon="time-management"-->
<!--        ></LeftFeature>-->
<!--        <RightFeature machine-name="autoscale"-->
<!--                      title="Handling Scale with Minimum Latency"-->
<!--                      description="Scale horizontally as your data sources grow in number and data volume. Handle millions of records per minute with minimum latency."-->
<!--                      icon="volume"-->
<!--        ></RightFeature>-->
<!--        <LeftFeature machine-name="user-roles"-->
<!--                     title="Unlimited Users, Sub-accounts, Roles Based Access Control"-->
<!--                     description="Grant granular access control for users, roles and accounts with two factor authentication."-->
<!--                     icon="fingerprint-simple-outline"-->
<!--        ></LeftFeature>-->
<!--        <RightFeature machine-name="simple"-->
<!--                      title="Private Cloud or On-Prem"-->
<!--                      description="Simple, best practice deployment to your cloud or on-prem environment that leave you in full control with minimum operational overhead."-->
<!--                      icon="padlock"-->
<!--        ></RightFeature>-->
<!--        <LeftFeature machine-name="security"-->
<!--                     title="Enterprise-Level Security"-->
<!--                     description="Enterprise-grade security with end-to-end encryption, two-factor authentication, access control and audit trail."-->
<!--                     icon="shield"-->
<!--        ></LeftFeature>-->

    </div>
</template>

<script>

    import HeroFeatures from '../features/HeroFeatures.vue'
    // import LeftFeature from '../features/LeftFeature.vue'
    // import RightFeature from '../features/RightFeature.vue'

    import GettingStarted from '../home/GettingStarted.vue'
    import SourceIntegrations from '../home/SourceIntegrations.vue'
    import RealTime from '../home/RealTime.vue'
    import PipelinesUi from '../home/PipelinesUi.vue'

    export default {
        name: 'Features',
        components: {
          HeroFeatures,
            // LeftFeature,
            // RightFeature,
          GettingStarted,
          SourceIntegrations,
          RealTime,
          PipelinesUi
        },
        props: {
            msg: String
        },
        head: {
            title: {
                inner: 'Skippr Features',
                separator: '-',
                complement: 'Data Integration and Preparation'
            },
            //omited
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
